'use client'

import React from 'react'
import Image from 'next/image'
import Script from 'next/script'
import { AffirmDataParsed } from '@segway/core/src/businessHooks/useProductAffirmData'

import { useRouter } from '@/i18n/navigation'
import { Button } from '@/ui'

import useCheckoutAffirm from '../../../../../../../hooks/checkout/useCheckoutAffirm'

type CheckoutAffirmWidgetProps = {
  totalPrice: number
  affirmData: AffirmDataParsed | null
  googleReCaptchaToken: string
}

// https://docs.affirm.com/payments/docs/open-affirm-checkout

/**
 * 结账页面 Affirm支付组件
 */
const CheckoutAffirmWidget = ({
  totalPrice,
  affirmData,
  googleReCaptchaToken,
}: CheckoutAffirmWidgetProps) => {
  const router = useRouter()
  const { affirmConfig, launchAffirm, setIsScriptLoad, isReady } = useCheckoutAffirm({
    totalPrice,
    affirmData,
    router,
    googleReCaptchaToken,
  })

  if (!affirmConfig) {
    return <div className="py-5 text-center text-[#aaa]">Loading...</div>
  }

  return (
    <div>
      <Script
        src={affirmConfig.script}
        strategy="afterInteractive"
        onLoad={() => {
          setIsScriptLoad(true)
          window.affirm?.ui.ready(() => {
            console.log('Affirm UI ready')
          })
        }}
        onError={() => console.error('Affirm SDK failed to load')}
      />

      {isReady ? (
        <>
          <div className="affirm-education">
            <Image
              src={affirmConfig.logoSrc || ''}
              alt=""
              style={{ objectFit: 'contain' }}
              width={80}
              height={24}
            />
            {/*<p>{affirmConfig.defaultEduDesc}</p>*/}
          </div>
          {/* 下单按钮 */}
          <Button className="mt-5" onClick={launchAffirm}>
            {affirmConfig.affirmTitle}
          </Button>
        </>
      ) : (
        <div className="py-5 text-center text-[#aaa]">Loading...</div>
      )}
    </div>
  )
}

export default CheckoutAffirmWidget
